import ErnstigeBloedingenOnderDoacDabigatran from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-doac-dabigatran.json";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderDoacDabigatran,
  React
};